import { render, staticRenderFns } from "./view.html?vue&type=template&id=be73db5c&scoped=true&"
import script from "./script.js?vue&type=script&lang=js&"
export * from "./script.js?vue&type=script&lang=js&"
import style0 from "./style.less?vue&type=style&index=0&id=be73db5c&lang=less&scoped=true&"
import style1 from "./style_mobile.less?vue&type=style&index=1&id=be73db5c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be73db5c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('be73db5c')) {
      api.createRecord('be73db5c', component.options)
    } else {
      api.reload('be73db5c', component.options)
    }
    module.hot.accept("./view.html?vue&type=template&id=be73db5c&scoped=true&", function () {
      api.rerender('be73db5c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/partials/crash_box/index.vue"
export default component.exports